/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

const processBarPlot = barPlot => (
  {
    ...barPlot.fields,
    ...barPlot.original
  }
)

export default processBarPlot
